/**
 * Split a `tab.path`-style URL fragment into its components.
 *
 * `tab.path` is stored as a full URL fragment (pathname + optional search + optional hash).
 * Various consumers — `matchPath`, route context, synthetic `Location`, navigator methods —
 * need just the pathname, or each component separately. This helper is the canonical splitter.
 *
 * Uses `URL` parsing with a stable opaque base (`http://_`) so we never have to depend on
 * `window.location` or worry about the page's actual origin.
 */
export interface FullPathParts {
  pathname: string;
  search: string; // includes leading '?' or empty
  hash: string; // includes leading '#' or empty
}

/**
 *
 */
export function splitFullPath(full: string): FullPathParts {
  const url = new URL(full, 'http://_');
  return {
    pathname: url.pathname,
    search: url.search,
    hash: url.hash,
  };
}
